import { useEffect, useRef } from "react";
import { renderPage } from "../lib/pdf.js";

export default function PdfPreview({ pdf, pageOps, selectedIndex, busy }) {
  const holderRef = useRef(null);
  const pageNumber = pageOps[selectedIndex]?.orig + 1;
  const rotation = pageOps[selectedIndex]?.rot || 0;

  useEffect(() => {
    let cancelled = false;
    if (!pdf || !pageNumber) return undefined;
    renderPage(pdf, pageNumber, 1.5).then((canvas) => {
      if (cancelled) return;
      const holder = holderRef.current;
      if (!holder) return;
      holder.replaceChildren(applyRotation(canvas, rotation));
    });
    return () => {
      cancelled = true;
    };
  }, [pdf, pageNumber, rotation]);

  if (!pdf) {
    return <div className="preview-empty">正在准备 PDF 预览{busy ? ` · ${busy}` : ""}</div>;
  }

  return (
    <div className="pdf-preview">
      <div className="pdf-page-info">
        第 {selectedIndex + 1} / {pageOps.length} 页
      </div>
      <div className="pdf-main" ref={holderRef} />
    </div>
  );
}

function applyRotation(canvas, deg) {
  const rot = ((deg % 360) + 360) % 360;
  if (!rot) return canvas;
  const swap = rot === 90 || rot === 270;
  const out = document.createElement("canvas");
  out.width = swap ? canvas.height : canvas.width;
  out.height = swap ? canvas.width : canvas.height;
  const ctx = out.getContext("2d");
  ctx.translate(out.width / 2, out.height / 2);
  ctx.rotate((rot * Math.PI) / 180);
  ctx.drawImage(canvas, -canvas.width / 2, -canvas.height / 2);
  return out;
}
